import { type GatsbySSR } from 'gatsby'
import React from 'react'

import { TokenProvider } from './token-provider'

// Fixme should be GatsbySSR | GatsbyBrowser but crash cause of any type
export const wrapPageElement: GatsbySSR['wrapPageElement'] = ({ element }) => (
  <TokenProvider>{element}</TokenProvider>
)
